import Vue from 'vue'
import App from './App.vue'
import router from './router'
import less from 'less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.css'
import "./assets/main.less"
import "@/assets/Animation_My.less"
import datas from './api/data.js'

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css'; // 引入样式
import '@/assets/animate.min.css'

Vue.use(Viewer);

Vue.use(VueAwesomeSwiper)
Vue.use(less)
Vue.config.productionTip = false
Vue.prototype.$Datas = datas
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
